import { render, staticRenderFns } from "./RDP.vue?vue&type=template&id=0546f666"
import script from "./RDP.vue?vue&type=script&lang=js"
export * from "./RDP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports